<template>
  <div class="cwTextInputMergerWrapper" v-show="isVisible">
    <div
      class="form-group"
      v-for="(cmp, index) in cmpConfig.component.data.components"
      :key="index"
    >
      <p>{{ getCactusString(cmp.label_static) }}</p>
      <!-- <pre>{{cmp}}</pre> -->
      <input
        :type="inputType"
        v-model="inputData[index]"
        v-on:change="valueChanged($event, cmp, index)"
        :disable="cmpConfig.component.enabled"
        :placeholder="getCactusString(cmp.label_hint)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _find from 'lodash/find';
// import _findIndex from 'lodash/findIndex';
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwTextInputMergerWrapper',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    },
    valueSet: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      inputData: [],
      outputData: []
    };
  },
  created() {
    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }

    this.setInputData();
  },
  computed: {
    ...mapGetters(['latestAppData']),
    listContent() {
      let valKey = 'default';
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
      }
      return this.cmpConfig.value[valKey];
    },

    isVisible() {
      if (this.cmpConfig.rule_subscriber) {
        return this.visibilityWithRules;
      } else {
        return true;
      }
    },

    valueFromFw() {
      let fwParams = this.getFwApp();
      return this.getAppValue(fwParams.app, fwParams.param) || this.defaultValue;
    },

    inputType() {
      let inputType = _find((this.fwParams || [])[0], 'type') || '';
      if (inputType.type.toLowerCase() === 'string') return 'text';
      return 'number';
    }
  },
  methods: {
    setInputData() {
      const initialInput = this.applyTransformations(this.valueFromFw);
      if (!initialInput) return;

      const separator = this.cmpConfig.component.data.separator;
      const dataInput = initialInput.split(separator);
      const components = this.cmpConfig.component.data.components;
      components.forEach((component, index) => {
        const values = [];
        component.in_concat_value.forEach(position => {
          values.push(dataInput[position]);
        });
        this.inputData[index] = values.join(separator);
      });

      this.outputData = this.inputData;
    },
    valueChanged(event, comp, index) {
      this.outputData[index] = event.target.value;

      let fwApp = this.getFwApp();
      let dataObj = this.getDataObj(fwApp, this.outputData.join(':'));

      this.$log.debug('cwTextInputMergerWrapper::valueChanged', dataObj);
      this.setExpertViewParams(dataObj);
    },
    getDataObj(fwApp, inputObj) {
      const baseObj = {
        app: fwApp.app,
        parameter: fwApp.param
      };

      if (this.inputType === 'text') {
        return {
          ...baseObj,
          value: inputObj
        };
      }

      return {
        ...baseObj,
        value: Number(this.applyReverseTransformations(inputObj))
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.cwTextInputMergerWrapper {
  .form-group {
    min-height: 58px;
    padding: 16px 0 0 16px;
    text-align: left;
    // border-top: 0.5px solid #becdd7;
    // border-bottom: 0.5px solid #becdd7;

    &:first-child {
      border-bottom: 0.5px solid #becdd7;
    }
    &:last-child {
      color: green;
    }

    p {
      @include textSmall;
      color: $bluey-grey;
    }

    input {
      border: none;
      text-align: right;
      padding: 10px 0 0 18px;
      @include textCharts;
      color: $petrol;
      width: 50px;

      &[type='text'] {
        width: auto;
        text-align: left;
      }
    }

    span {
      padding-left: 3px;
      @include textCharts;
      color: $petrol;
    }
  }
}
</style>
